import React, { forwardRef } from "react";

import { calcStay, formatRoomTypes } from "./reservationExportUtils";
import {
  getReservationNo,
  normalizeType,
  STATUS_META,
} from "./reservationViewUtils";

const GRID_COLUMNS = "0.9fr 1fr 1fr 0.8fr 2fr 1.5fr 1.2fr 1fr 1fr 0.8fr";

const ReservationTable = forwardRef(({
  reservations,
  onView,
}, ref) => {
  const getStatusColor = (reservationType) =>
    STATUS_META[normalizeType(reservationType)].background;

  return (
    <div ref={ref} style={{ width: "100%" }}>
      {/* Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: GRID_COLUMNS,
          backgroundColor: "#5ec3a4",
          color: "#fff",
          fontWeight: 700,
          padding: "12px 8px",
          borderRadius: "8px 8px 0 0",
          textAlign: "center",
        }}
      >
        {[
          "Reservation No",
          "Check In",
          "Check Out",
          "Stay",
          "Hotel",
          "Room Type",
          "Guest",
          "Phone No",
          "Source",
          "Actions",
        ].map((header) => (
          <div
            key={header}
            className={header === "Actions" ? "export-hide" : undefined}
          >
            {header}
          </div>
        ))}
      </div>

      {/* Body */}
      <div style={{ marginTop: "8px" }}>
        {reservations.length ? (
          reservations.map((item) => (
            <div
              key={item.id}
              style={{
                display: "grid",
                gridTemplateColumns: GRID_COLUMNS,
                backgroundColor: getStatusColor(item.reservationType),
                borderRadius: "8px",
                marginBottom: "8px",
                minHeight: "4em",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div style={{ fontWeight: 600 }}>{getReservationNo(item)}</div>
              <div>{item.checkIn}</div>
              <div>{item.checkOut}</div>
              <div>{calcStay(item.checkIn, item.checkOut)} nights</div>
              <div>{item?.hotelName || "-"}</div>
              <div>{formatRoomTypes(item.roomDetails)}</div>
              <div>
                {[item.firstName, item.lastName].filter(Boolean).join(" ") || "-"}
              </div>
              <div>{item.mobile}</div>
              <div>{item.source || "-"}</div>
              <div className="export-hide" style={{ textAlign: "center" }}>
                <button
                  type="button"
                  title="View reservation"
                  onClick={() => onView(item)}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                >
                  <i
                    className="fa-solid fa-eye"
                    style={{ color: "#4CBC9A", fontSize: "16px" }}
                  ></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              fontStyle: "italic",
              color: "#888",
            }}
          >
            No reservations found
          </div>
        )}
      </div>
    </div>
  );
});

ReservationTable.displayName = "ReservationTable";

export default ReservationTable;
